const TZ = "Europe/Rome";

export function fmtDateTime(iso) {
  if (!iso) return "—";
  return new Intl.DateTimeFormat("it-IT", {
    timeZone: TZ, day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit",
  }).format(new Date(iso));
}

export function fmtDate(iso) {
  if (!iso) return "—";
  return new Intl.DateTimeFormat("it-IT", {
    timeZone: TZ, weekday: "short", day: "2-digit", month: "long",
  }).format(new Date(iso));
}

export function fmtDay(iso) {
  if (!iso) return "—";
  return new Intl.DateTimeFormat("it-IT", {
    timeZone: TZ, day: "2-digit", month: "2-digit", year: "numeric",
  }).format(new Date(iso));
}

export function fmtTime(iso) {
  if (!iso) return "—";
  return new Intl.DateTimeFormat("it-IT", {
    timeZone: TZ, hour: "2-digit", minute: "2-digit",
  }).format(new Date(iso));
}

export function countdownParts(targetIso) {
  const diff = new Date(targetIso).getTime() - Date.now();
  if (diff <= 0) return null;
  const d = Math.floor(diff / 86400000);
  const h = Math.floor((diff % 86400000) / 3600000);
  const m = Math.floor((diff % 3600000) / 60000);
  const s = Math.floor((diff % 60000) / 1000);
  return { d, h, m, s };
}

export function euro(v, currency = "EUR") {
  return new Intl.NumberFormat("it-IT", { style: "currency", currency }).format(v || 0);
}
